import { useEffect } from 'react';

const SEOHead = ({
  title = "Arieri's World Limited - Leading Technology Solutions Provider in Kenya",
  description = "Expert web development, cloud computing, data analytics & mobile app development services in Kenya. Transform your business with innovative technology solutions.",
  keywords = "web development Kenya, cloud computing services, data analytics, mobile app development, digital transformation, technology solutions Kenya",
  url = "https://arierisworld.com",
  image = "https://arierisworld.com/assets/logo2.webp",
  type = "website"
}) => {
  
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    }
    
    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;
    
    // Update Open Graph tags
    const updateOGTag = (property, content) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    
    updateOGTag('og:title', title);
    updateOGTag('og:description', description);
    updateOGTag('og:url', url);
    updateOGTag('og:image', image);
    updateOGTag('og:type', type);
    
    // Update Twitter Card tags
    const updateTwitterTag = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    
    updateTwitterTag('twitter:title', title);
    updateTwitterTag('twitter:description', description);
    updateTwitterTag('twitter:image', image);
    
  }, [title, description, keywords, url, image, type]);
  
  return null; // This component doesn't render anything
};

export default SEOHead;